import ky, { type Options } from 'ky';
import { type StateCreator } from 'zustand';
import { LoginThemes } from '../hooks/useDefaultLoginTheme';
import { apiEndpoints } from '../../lib/apiEndpoints/apiEndpoints';

export type LoginSettings = {
  portalEnabled: boolean;
  tenantCode: string;
  signInGuidance: boolean;
  signInGuidanceText: string | null | undefined;
  authenticationMode: 'OTPV2' | 'SSO';
  authenticationParameters: {
    app: string;
    mode: string;
    clientId: string;
    userPoolId: string;
    accessScope: string;
    authDomain: string;
    idP: string;
  } | null;
  backgroundUrl: string | null | undefined;
  logoUrl: string | null | undefined;
  signInTheme: LoginThemes | null | undefined;
};

type AuthStoreState = {
  isFetching: boolean;
  tenantId?: string;
  error: string | null;
  loginSettings: LoginSettings | null;
};

type AuthStoreActions = {
  init: (tenantId?: string) => void;
};

export type AuthStore = AuthStoreState & AuthStoreActions;

export const auth: StateCreator<AuthStore> = (set) => {
  const store: AuthStore = {
    isFetching: false,
    error: null,
    loginSettings: null,
    async init(tenantId) {
      console.log('Initializing');
      set({ tenantId, isFetching: true });
      try {
        const kyOpts: Options = {
          ...(tenantId ? { headers: { 'OT-Customer-Id': tenantId } } : {}),
        };
        const apiBaseURL = apiEndpoints.getAPIEndpoint('root');

        if (apiBaseURL == null) {
          throw new Error('endpoint "root" is not defined');
        }
        const loginSettings = await ky.get(`${apiBaseURL}/login/settings`, kyOpts).json<LoginSettings>();
        set({ loginSettings });
      } catch {
        set({
          loginSettings: {
            portalEnabled: false,
            tenantCode: tenantId?.toUpperCase() || 'DEMO',
            signInGuidance: false,
            signInGuidanceText: undefined,
            authenticationMode: 'OTPV2',
            authenticationParameters: null,
            backgroundUrl: undefined,
            logoUrl: undefined,
            signInTheme: undefined,
          },
        });
      } finally {
        set({
          isFetching: false,
        });
      }
    },
  };
  return store;
};
